import React from 'react';
import I18n from 'i18n-js';

import { categoryForSlug, CategoryConfig } from '../category_data';
import classNames from 'classnames';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import { RCGrid, RCImage } from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import URLHelpers from '../../shared/url_helpers';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';

const categoryList = [
  'electric-guitars',
  'keyboards-and-synths',
  'effects-and-pedals',
  'pro-audio',
  'dj-and-lighting-gear',
  'acoustic-guitars',
  'bass-guitars',
  'amps',
  'drums-and-percussion',
  'band-and-orchestra',
].map(categoryForSlug);

const ROW_ONE_TOTAL = 6;

interface CategoryCardProps {
  categoryItem: CategoryConfig;
  position: number;
  horizontal?: boolean;
}

function CategoryCard(props: CategoryCardProps) {
  const cardClasses = classNames(
    'category-item-redesign',
    { 'category-item-main-row': !props.horizontal },
    { 'category-item-overflow': props.horizontal },
  );

  const categoryText = I18n.t(`discovery.taxonomy.${props.categoryItem.uuid}`);

  return (
    <CoreLink
      to={URLHelpers.categoryPagePath(props.categoryItem.slug)}
      trackName="RedesignedCategoriesRow"
      entityId={props.categoryItem.uuid}
      position={props.position}
      className={cardClasses}
      clickEvent={{
        componentName: 'RedesignedCategoryCard',
        eventName: MParticleEventName.ClickedCategory,
        category: props.categoryItem.slug,
      }}
    >
      <RCImage
        src={props.categoryItem.image_v3}
        aspect={props.horizontal ? 1 : 0.83}
        imageBox="auto"
        borderRadius="lg"
      />
      <div className="category-item__footer">
        <div className="category-item__text">
          {categoryText}
        </div>
      </div>
    </CoreLink>
  );
}

export default function HomepageCategories() {
  return (
    <OverflowingRow title={I18n.t('discovery.homepage.loggedOutNew.browseByCategory')}>
      <RCGrid singleRowOn="mobile">
        {categoryList.map((category, index) => {
          const horizontal = index > (ROW_ONE_TOTAL - 1);
          const cardColSpan = horizontal ? 3 : 2;
          return (
            <RCGrid.Item
              colSpan={{ desktop: cardColSpan, tablet: cardColSpan, mobile: 8 }}
              key={category.slug}
            >
              <CategoryCard
                categoryItem={category}
                position={index}
                horizontal={horizontal}
              />
            </RCGrid.Item>
          );
        })}
      </RCGrid>
    </OverflowingRow>
  );
}
